import type { ElementState, Origin } from "../api/types";

/**
 * The seven looks of the visual language. Colour is for state only. "missing" is the look of something that is needed
 * and not there yet (a grey bar, a grey dot): it is a count in the progress views, never a state of one element.
 */
export type DisplayState = "proposed" | "waiting" | "validated" | "sent_back" | "rejected" | "loaded" | "missing";

export const STATE_WORDS: Record<DisplayState, string> = {
  proposed: "Proposed",
  waiting: "Waiting for the SME",
  validated: "Validated",
  sent_back: "Sent back",
  rejected: "Rejected",
  loaded: "Loaded",
  missing: "Missing",
};

/**
 * What to show for an element. Null state with origin "loaded" is loaded reference data;
 * accepted and added by hand both wait for the SME (BUILD-PLAN 2.4.3). A proposal is a card that is not settled yet.
 */
export function displayState(
  state: ElementState | null | undefined,
  options: { origin?: Origin; proposed?: boolean } = {},
): DisplayState | null {
  if (options.proposed) return "proposed";
  switch (state) {
    case "accepted":
    case "added_by_hand":
      return "waiting";
    case "validated":
      return "validated";
    case "sent_back":
      return "sent_back";
    case "rejected":
      return "rejected";
    case "withdrawn":
    case "removed":
      return null; // gone from the screens
    case null:
    case undefined:
      return options.origin === "loaded" ? "loaded" : null;
  }
}
